import {
  Button,
  Drawer,
  DrawerProps,
  makeStyles,
} from "@fluentui/react-components";

import { Dismiss24Regular } from "@fluentui/react-icons";
import { FluentProvider } from "@/dependencies";
import DrawerHeader from "./DrawerHeader";
import DrawerHeaderTitle from "./DrawerHeader/DrawerHeaderTitle";

interface DrawerCustomProps {
  headerText?: string | React.ReactNode;
  onDismiss?: () => void;
  rcName?: string;
  theme?: string;
  isUnmounted?: boolean;
}

const useStyles = makeStyles({
  drawer: {
    height: "calc(100% - 48px)",
    top: "48px",
    "& .fui-DrawerBody": {
      marginTop: "0px !important",
      paddingTop: "var(--spacingVerticalL)",
    }
  },
  backdrop: {
    height: "calc(100% - 48px)",
    top: "48px",
  },
});

const DrawerCustom = (props: DrawerCustomProps & DrawerProps) => {
  const styles = useStyles();

  const drawerForUnmounted = () => {
    return props.open ? (
      <Drawer
        separator
        {...props}
        open={true}
        position="end"
        modalType="modal"
        className={styles.drawer}
        backdrop={{
          className: styles.backdrop,
        }}
        
       //unmountOnExit={true}
      >
        {props.headerText && (
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={props.onDismiss}
                />
              }
            >
              {props.headerText}
            </DrawerHeaderTitle>
          </DrawerHeader>
        )}
        {props.children}
      </Drawer>
    ) : null;
  };

  const renderDrawer = () => {
    return (
      <Drawer
        separator
        {...props}
        position="end"
        modalType="modal"
        className={styles.drawer}
        backdrop={{
          className: styles.backdrop,
        }}
      >
        {props.headerText && (
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="Close"
                  icon={<Dismiss24Regular />}
                  onClick={props.onDismiss}
                />
              }
            >
              {props.headerText}
            </DrawerHeaderTitle>
          </DrawerHeader>
        )}
        {props.children}
      </Drawer>
    );
  };

  return <FluentProvider theme={props.theme} className={styles.drawer}>
    {props.isUnmounted ? drawerForUnmounted() : renderDrawer()}
  </FluentProvider>;
};

export default DrawerCustom;
